import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

import { Observable, BehaviorSubject } from 'rxjs';
import { tap, switchMap, filter, take } from 'rxjs/operators';

import { AuthService } from './service/auth.service';
import { NotificationService } from './service/notification.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    public authService: AuthService,
    private notify: NotificationService
  ) { }

  isRefreshingToken = false;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.addTokenToRequest(request, this.authService.getAuthToken())).pipe(tap(() => { },
      error => {
        let errorObjs;

        if (error.status === 401) { // 401 returned for no or expired token
          return this.handle401Error(request, next);
        } else if (error.status > 399 && error.status !== 403) {
          errorObjs = this.bulidErrorArray(error.error.error.message);
        } else {
          errorObjs = this.bulidErrorArray('There was an error processing a request.');
        }

        if (error.status !== 404) {
          this.notify.showError(errorObjs);
        }
      }));
  }

  addTokenToRequest(request: HttpRequest<any>, token: string): HttpRequest<any> {
    if (token) {
      return request.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
    } else {
      return request;
    }
  }

  handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshingToken) {
      this.isRefreshingToken = true;

      // Reset here so that the following requests wait until the token
      // comes back from the refreshToken call.
      this.tokenSubject.next(null);

      return this.authService.refreshToken()
        .then(user => {
          if (user) {
            this.tokenSubject.next(user.authToken);
            localStorage.setItem('currentUser', JSON.stringify(user));
            return next.handle(this.addTokenToRequest(request, user.authToken));
          }

          return this.authService.doLogout() as any;
        }
        ).catch(err => {
          return this.authService.doLogout() as any;
        }).finally(() => {
          this.isRefreshingToken = false;
        });
    } else {
      this.isRefreshingToken = false;

      return this.tokenSubject
        .pipe(filter(token => token != null),
          take(1),
          switchMap(token => {
            return next.handle(this.addTokenToRequest(request, token));
          }));
    }
  }

  bulidErrorArray(errors: any, url?: string) {
    const errorObjs = [];
    const errorType = '';

    if (errors instanceof Array) {
      for (const e of errors) {
        errorObjs.push({ type: errorType, error: e.ResxFullMessage });
      }
    } else {
      errorObjs.push({ type: errorType, error: errors });
    }

    return errorObjs;
  }
}

